import { InjectionToken } from '@angular/core';

export const APP_REFRESH_INTERVAL = new InjectionToken<number>('app-refresh-interval', {
  providedIn: 'root',
  factory: () => 3000
});
